/* lua.js generated code 0.3.0 */
let kMainLevel   = require("clover/logic/userLevel/UserLevelTypeMainLevel")
//let kEditor      = require("clover/logic/userLevel/UserLevelTypeEditor")
module.exports = table(
    [1, GameLevelType.kMainLevel, kMainLevel],
    [1, GameLevelType.kMysteryIsland, require("clover/logic/userLevel/UserLevelTypeMysteryIslandLevel")],
    [1, GameLevelType.kBuildShip, require("activity/BuildShip/levelLogic/BuildShipUserLevelType")],
    
    //[1, GameLevelType.kEditor, kEditor]
)
